import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line
import * as browserHistory from 'react-router-dom';
import analytics from 'react-segment';

import './index.css';
import App from './App';

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  analytics.default.load('HAcxJ9HCjgjAICRIHzKWZ4rCIS6WIjdG');
}

if (
  process.env.REACT_APP_ENVIRONMENT === 'development' ||
  process.env.REACT_APP_ENVIRONMENT === 'review' ||
  process.env.REACT_APP_ENVIRONMENT === 'staging'
) {
  analytics.default.load('d4U9TEqwwtpJ9PJB228s9MoLCoXasEYc');
}

ReactDOM.render(
  <App history={browserHistory} />,
  document.getElementById('root')
);
